import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { SecurityType } from './constants/security-type.enum';
import { AuthService } from './data/auth.service';
import { CampaignService } from './data/campaign-service';

@Injectable({
    providedIn: 'root'
})
export class StudentGuard {

    private isRestricted = false;

    constructor(private authService: AuthService, private router: Router, private campaignService: CampaignService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {

        if (this.isRestricted && state.url !== '/student/restricted') {
            this.router.navigate(['/student/restricted']);
            return false;
        }

        // Lets determine where the student should land based on their campaign status.
        // The default route is "dashboard" so we need to redirect as needed.
        if (state.url === '/student/dashboard')
            return new Promise(resolve => {
                combineLatest([
                    this.campaignService.createStudentInfoRecord(),
                    this.campaignService.getCampaignStatus(),
                ]).pipe(
                    tap(([
                        ,
                        campaignStatus,
                    ]) => {
                        // Brand new user -- show a welcome screen.
                        if (campaignStatus.showWelcomePage) {
                            this.router.navigate(['/student/welcome']);
                            resolve(false);
                        }
                        // New user has not yet finished the onboarding process.
                        else if (campaignStatus.showOnboardingPage) {
                            this.router.navigate(['/student/onboarding']);
                            resolve(false);
                        }
                        // Ok let them through to the dashboard.
                        else
                            resolve(true);
                    })).subscribe();
            });

        // Not trying to determine the initial route... go ahead and let them through.
        return true;
    }

    canLoad = () => this.authService.getAuthInfo().pipe(
        tap(auth => this.isRestricted = auth.isRestricted),
        map(auth => auth.userType === SecurityType.CampusLogic || auth.userType === SecurityType.Student)
    )
}
